const hostname = window.location.hostname;

/* teste da vps com o novo banco */
const API_DEV =
	process.env.REACT_APP_API_DEV; /* process.env.REACT_APP_API_DEV; */
const API_PROD = process.env.REACT_APP_API_PROD;
const API_DEV_HOSTS = process.env.REACT_APP_API_DEV_HOSTS || '';

let API_BASE_URL;

const devHosts = API_DEV_HOSTS.split(',')
	.map((host) => host.trim())
	.filter(Boolean);

if (devHosts.includes(hostname)) {
	API_BASE_URL = API_DEV;
} else {
	API_BASE_URL = API_PROD;
}

export default API_BASE_URL;
